import xlsx from 'json-as-xlsx'

export const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/**
 * It takes an array of objects, converts it to a CSV string, and then downloads
 * the CSV file
 * @param headers - An array of the CSV columns
 * @param items - The data you want to export.
 * @param fileTitle - The title of the file.
 */
export const exportCSVFile = (headers, items, fileTitle) => {
  if (headers) {
    items.unshift(headers)
  }

  const date = new Date()
  const title = fileTitle + date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes()) + pad2(date.getSeconds())
  // Convert Object to JSON
  const jsonObject = JSON.stringify(items)
  const csv = convertToCSV(jsonObject)
  const exportedFilenmae = title + '.csv' || 'export.csv'
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })

  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilenmae)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export const exportXLSXFile = (headers, items, title) => {
  const date = new Date()
  const filename = title + date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes()) + pad2(date.getSeconds())

  const data = [
    {
      sheet: 'Sheet 1',
      columns: Object.entries(headers).map(entry => ({ label: entry[1], value: entry[0] })),
      content: items
    }
  ]

  const settings = {
    fileName: filename,
    writeMode: 'writeFile',
    writeOptions: {}
  }

  xlsx(data, settings)
}

/**
 * It takes an array of objects and returns a string of comma separated values
 * @returns A string
 */
const convertToCSV = objArray => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
  let str = ''

  for (let i = 0; i < array.length; i++) {
    var line = ''
    for (const index in array[i]) {
      if (line !== '') line += ','
      const value = array[i][index]
      line += typeof value === 'string' ? `"${value}"` : value
    }

    str += line + '\r\n'
  }

  return str
}

/**
 * If the number is less than 10, return a string with a zero and the number,
 * otherwise return the number.
 * @param n - The number to be formatted.
 * @returns the value of the variable n.
 */
function pad2 (n) { return n < 10 ? '0' + n : n }
